<template>
    <fade-up-animation :element="() => $refs.section">
        <div class="read-more" ref="section">
            <b-button
                variant="link"
                class="toggle-button"
                v-b-toggle.readMoreContent
                @click="visible = !visible"
                v-test:toggleButton
            >
                <span
                    class="button-text"
                    v-test:buttonText
                >{{ buttonText }}</span>

                <span class="icon-container">
                    <app-icon
                        :name="visible ? 'minus' : 'plus'"
                        alt="Toggle read more content"
                        class="toggle-icon"
                        :class="{ visible }"
                        v-test:toggleIcon
                    />
                </span>
            </b-button>

            <b-collapse
                id="readMoreContent"
                class="read-more-content"
            >
                <div class="content">
                    <markdown-content :content="content" />
                </div>
            </b-collapse>
        </div>
    </fade-up-animation>
</template>

<script>
    import MarkdownContent from '../../utils/MarkdownContent/MarkdownContent';
    import { BCollapse, VBToggle } from 'bootstrap-vue';

    export default {
        name: 'read-more',

        components: { MarkdownContent, BCollapse },

        directives: {
            'b-toggle': VBToggle,
        },

        props: {
            buttonText: {
                type: String,
                default: '',
            },

            content: {
                type: String,
                default: '',
            },
        },

        data() {
            return {
                visible: false,
            };
        },
    };
</script>

<style lang="scss" scoped>
    .read-more {
        text-align: center;
    }

    .toggle-button {
        margin-bottom: 10px;
        color: #bdbdbd;
        display: inline-flex;
        align-items: center;
        padding: 2.5px 5px;

        &:hover,
        &:focus-visible,
        &:active {
            outline: 1px solid $itsu-primary;
        }
    }

    .button-text {
        font-size: rem(12px);
        font-weight: 400;
        padding-right: 7px;
    }

    .app-icon {
        height: 7px;
        fill: primary-palette(1);
        display: block;

        &.visible {
            height: 4px;
        }
    }

    .icon-container {
        height: 14px;
        width: 14px;
        background-color: secondary-palette(7);
        border-radius: 50%;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .read-more-content {
        color: #bdbdbd;
        font-size: rem(12px);
    }
</style>
